import script from "./SellerApplication.vue?vue&type=script&setup=true&lang=js"
export * from "./SellerApplication.vue?vue&type=script&setup=true&lang=js"

import "./SellerApplication.vue?vue&type=style&index=0&id=50c39e42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50c39e42"]])

export default __exports__